import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

export function useChatFile(msg) {
  const [url, setUrl] = useState(null);
  const [gone, setGone] = useState(false);
  const live = msg && !msg.expired && ["image", "audio", "pdf"].includes(msg.type);
  useEffect(() => {
    if (!live) return;
    let alive = true;
    if (!cache.has(msg.msg_id)) {
      cache.set(msg.msg_id, api.get(`/chat/files/${msg.msg_id}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data)));
    }
    cache.get(msg.msg_id).then((u) => alive && setUrl(u)).catch(() => {
      cache.delete(msg.msg_id);
      if (alive) setGone(true);
    });
    return () => { alive = false; };
  }, [live, msg?.msg_id]);
  return { url, gone: gone || msg?.expired };
}

export const uploadChat = (path, file, duration) => {
  const fd = new FormData();
  fd.append("file", file, file.name || "file");
  if (duration) fd.append("duration", String(duration));
  return api.post(path, fd);
};

export const fmtClock = (iso) => new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" });
export const fmtDay = (iso) => new Date(iso).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Jakarta" });
export const fmtSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
export const hoursLeft = (iso) => Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 3600000));

export function useUnreadChat(path, ms = 10000, field = "unread") {
  const [n, setN] = useState(0);
  useEffect(() => {
    const load = () => api.get(path).then((r) => setN(r.data[field])).catch(() => {});
    load();
    const t = setInterval(load, ms);
    window.addEventListener("cu-chat-read", load);
    window.addEventListener("cu-help-changed", load);
    return () => { clearInterval(t); window.removeEventListener("cu-chat-read", load); window.removeEventListener("cu-help-changed", load); };
  }, [path, ms, field]);
  return n;
}
